export default "__VITE_ASSET__1f4da5ac__"